import EfScrollAni from '@/efscrollani';
import { useRouter } from 'next/router';
import A from './comps/A';
import B from './comps/B';
import C from './comps/C';
import D from './comps/D';
import E from './comps/E';
import F from './comps/F';
import FixTab from './comps/FixTab';
import G from './comps/G';
import TC from './comps/TC';
import css from './index.module.scss';

const Page: React.FC = () => {
    if (typeof window !== 'undefined' && !window.AniContainer) {
        window.AniContainer = new EfScrollAni();
    }

    const { locale = 'us' } = useRouter();
    const IS_EU = ['de', 'fr', 'it', 'es', 'uk', 'eu'].includes(locale);

    return (
        <div className={`${css.page} rapid-series`}>
            <A />
            <FixTab />
            <B />
            <C />
            <D />
            {/* {IS_EU && <H />} */}
            <E />
            <G />
            <F />
            {IS_EU && <TC />}
        </div>
    );
};

export default Page;
